import(/* webpackMode: "eager", webpackExports: ["Header","Trigger"] */ "/app/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/google-recaptcha-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionContent"] */ "/app/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlurFade"] */ "/app/src/components/ui/blur-fade.tsx");
